(function(){
  var sizeTimer, lastPagePoint;

  Pegasus.ImageGalleryView = Em.View.extend({
    classNames: ['vr-image-gallery'],
    classNameBindings: ['controller.isIconsList:is-icons-list'],

    templateName: 'image_gallery/view',
    topBar: Em.View.extend({
      classNames: ['vr-image-gallery-top-bar'],
      templateName: 'image_gallery/top_bar',
      didInsertElement: function(){
        this._super();
        $(window).on('keydown.' + this.get('elementId'), function(e){
          if ( this.$() && this.get('pressedKey') ) {
            this.pressedKey.call(this, e.keyCode );
          }
        }.bind(this));
      },

      iconColorPickerView: Pegasus.BoundPropertyColorBoxView.extend({
        propertyBinding: 'controller.selectedIconColor',
        propertyName: "iconColor"
      }),

      pressedKey: function(code){
        switch(code) {
        case 27:
          Em.run( this.get('controller'), 'cancel' );
          break;
        case 13:
          Em.run( this.$('.vr-search-button'), 'click');
        }
      }
    }),
    bottomBar: Em.View.extend({
      classNames: ['vr-image-gallery-bottom-bar'],
      templateName: 'image_gallery/bottom_bar'
    }),
    loadingView: Em.View.extend({
      classNames: ['vr-loading-images'],
      template: Em.Handlebars.compile('{{t g.loading}}...')
    }),
    imagesView: Em.View.extend({
      classNames: ['vr-images'],
      templateName: 'image_gallery/page_wrapper',

      didInsertElement: function(){
        this._super();
        this.bindScroll();
      },

      bindScroll: function(){
        var scrollFunction = function(e){
          var ul = $('.vr-loading-images');
          if ( !this.$() ) { return; }
          if ( ul.length && ul.last().offset().top < this.$().height() ) {
            Em.run.cancel(sizeTimer);
            sizeTimer = Em.run.later( this.get('controller'), 'getNextPage', 100);
          }
        }.bind(this);
        this.get('element').onscroll = scrollFunction;
        $(window).on('scrollImageGallery', scrollFunction);
      },

      pagesView: Em.CollectionView.extend({
        dataSourceBinding: 'controller.pages',

        content: function(){
          return this.get('dataSource');
        }.property('dataSource'),

        itemViewClass: Em.View.extend({
          templateName: 'image_gallery/images_wrapper',

          isThisEmail: function(){
            return this.get('content.dated') === Em.I18n.t('g.this_email');
          }.property('content.dated'),

          images: Em.CollectionView.extend({
            classNames: ['vr-images-collection'],

            contentBinding: 'parentView.content.photos',

            didInsertElement: function(){
              this._super();
              $(window).trigger('scrollImageGallery');
            },

            willDestroyElement: function(){
              this._super();
            },

            itemViewClass: Em.CollectionView.extend({
              tagName: 'ul',
              classNames: ['vr-image-item-group'],

              didInsertElement: function(){
                this._super();
                var self = this;
                this.$().imagesLoaded().always(function(){
                  if ( this.$() ) {
                    Em.run( self.get('childViews'), 'invoke', 'styleDidChange' );
                  }
                }.bind(this));
                Em.run.scheduleOnce('afterRender', this.get('controller'), 'didChangeSelectedIconColor');
              },

              itemViewClass: Em.View.extend({
                classNames: ['vr-image-item'],
                classNameBindings: ['flipped', 'single'],

                hasDifferentSizes: function(){
                  return this.get('content.data.src.small') !== this.get('content.data.src.medium') && (this.get('content.data.src.large') !== this.get('content.data.src.small'));
                }.property('content.data.src.@each'),

                didInsertElement: function(){
                  this._super();
                  this.bindResize();
                },

                willDestroyElement: function(){
                  this.unbindResize();
                  this._super();
                },

                deleteThis: function(){
                  var isLast = this.get('parentView.length') === 1 &&
                        this.get('parentView.parentView.content').flatten().length === 1,
                    isSecondToLast = this.get('parentView.length') === 2;

                  var parent = this.get('parentView');
                  this.get('controller').send('deleteThis', this.get('content'));
                  // Remove the week view if there are no more images to display
                  if ( isLast ) {
                    parent.get('parentView.parentView').remove();
                  }

                  if ( isSecondToLast ) {
                    this.get('parentView.firstObject').set('content.single', true);
                  } else {
                    $(window).trigger('resize');
                  }

                },

                isDeletable: function(){
                  var host = '[verticalresponse.com|localhost:\\d+]',
                    path = '/images/\\d+/',
                    regexp = new RegExp( host + path, 'i'),
                    subject = this.get('content.src');

                  return regexp.test(subject);
                }.property('content.src'),

                flipped: false,

                singleBinding: 'content.single',

                shouldResize: 0,

                resizeTimer: null,

                bindResize: function(){
                  $(window).on('resize.' + this.get('elementId'), function(){
                    this.styleDidChange();
                  }.bind(this));
                },

                unbindResize: function(){
                  $(window).off('resize.'+ this.get('elementId'));
                },

                styleDidChange: function(){
                  var height = ( this.$().closest('.vr-images').width() / this.get('parentView.content').mapProperty('aspectRatio').sum() ) - Math.sqrt(this.get('parentView.content.length'));
                  if ( this.get('single') ) {
                    height = height / 2;
                  }
                  var width = this.get('content.aspectRatio') * height;
                  this.$().css({
                    width:  width,
                    height: height
                  });
                },

                click: function(){
                  this.get('controller.controllers.' + this.get('controller.loadingControllerName') ).sizeContent(this);

                  $(window).trigger('flip');
                  this.toggleProperty('flipped');
                },

                templateName: 'image_gallery/card',

                didInsertElement: function(){
                  this._super();
                  this.bindFlip();
                  this.bindResize();

                  Em.run.scheduleOnce('afterRender', this, function(){
                    Em.propertyDidChange( this, 'parentView.content.length');
                  });
                },

                willDestroyElement: function(){
                  this.unbindFlip();
                  this.unbindResize();
                  this._super();
                },
                unbindFlip: function(){
                  $(window).off('flip.'+this.get('elementId'));
                  this._super();
                },
                bindFlip: function(){
                  $(window).on('flip.' +this.get('elementId'), function(){
                    if ( this.get('flipped') ) {
                      this.set('flipped', false);
                    }
                  }.bind(this));
                }
              })
            })
          })
        })
      })
    })
  });
})();
